export default "__VITE_ASSET__DIGdKh4w__"